import {
  ApiBlueprint,
  PageBlueprint,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';
import {
  createApiFactory,
  discoveryApiRef,
  identityApiRef,
} from '@backstage/core-plugin-api';
import {
  graphiQLRouteRef,
  graphQlBrowseApiRef,
  GraphQLEndpoints,
} from '@backstage-community/plugin-graphiql';

export const graphiqlModule = createFrontendModule({
  pluginId: 'graphiql',
  extensions: [
    // ── Route (→ app/routes) ────────────────────────────────
    PageBlueprint.make({
      params: {
        path: '/graphiql',
        noHeader: true,
        routeRef: graphiQLRouteRef,
        loader: () =>
          import('@backstage-community/plugin-graphiql').then(m => (
            <m.GraphiQLPage />
          )),
      },
    }),

    // ── API (→ global API registry) ─────────────────────────
    ApiBlueprint.make({
      name: 'custom-graphql-browse',
      params: defineParams =>
        defineParams(
          createApiFactory({
            api: graphQlBrowseApiRef,
            deps: {
              discovery: discoveryApiRef,
              identity: identityApiRef,
            },
            factory: ({ discovery, identity }) =>
              GraphQLEndpoints.from([
                {
                  id: 'backstage-backend',
                  title: 'Backstage GraphQL API',
                  fetcher: async (params: Record<string, unknown>) => {
                    const credentials = await identity.getCredentials();
                    const graphqlURL = await discovery.getBaseUrl('graphql');
                    return fetch(graphqlURL, {
                      method: 'POST',
                      headers: {
                        'Content-Type': 'application/json',
                        ...(credentials.token
                          ? {
                              Authorization: `Bearer ${credentials.token}`,
                            }
                          : {}),
                      },
                      body: JSON.stringify(params),
                    }).then(res => res.json());
                  },
                },
              ]),
          }),
        ),
    }),
  ],
});
